package com.rosario.juridico.ui

import androidx.compose.runtime.*
import kotlinx.browser.window

@Composable
actual fun CommonBackHandler(enabled: Boolean, onBack: () -> Unit) {
    val currentOnBack by rememberUpdatedState(onBack)

    if (enabled) {
        DisposableEffect(enabled) {
            val handlePopState = { _: org.w3c.dom.events.Event ->
                currentOnBack()
            }
            
            window.addEventListener("popstate", handlePopState)
            
            // Agregamos una entrada al historial para poder capturar el evento 'back' del navegador
            // sin recargar la página.
            window.history.pushState(null, "", window.location.href)
            
            onDispose {
                window.removeEventListener("popstate", handlePopState)
            }
        }
    }
}
